import { render, staticRenderFns } from "./rwluarnegeri.vue?vue&type=template&id=199d57c2"
import script from "./rwluarnegeri.vue?vue&type=script&lang=js"
export * from "./rwluarnegeri.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports